import i18n from '@plugins/i18n';

import BaseValidator from './BaseValidator';

export class TaxReferenceValidator extends BaseValidator {
    static key = 'taxReferenceValidator';

    static validator(value) {
        let valid = false;

        if (!value) {
            return true;
        }

        if (typeof value === 'object') {
            valid = [value.tax_reference_number_type, value.tax_reference_number, value.jurisdiction].every(v => v);
        }

        if (!valid) {
            return i18n.t('validator.tax_reference');
        }

        return true;
    }

    static arguments() {
        return [];
    }
}

export default TaxReferenceValidator;
